export const opomena_pred_tuzbu = {
    templateId: 51.2,
    category: 6,
    templateTitle: "Opomena pred tužbu",
    templateDescription: `<p>Upućivanje opomene pred tužbu nije zakonski preduvjet pokretanja postupka prisilne naplate. Također, opomena pred tužbu ne prekida zastaru i ne utječe na tijek zateznih kamata.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Značaj opomene ogleda se u tome što vjerovnik opomenom poziva dužnika da postupi u skladu s vlastitim obvezama (plati dug i sl.), a potom vjerovnik eventualno u opomeni navodi koje radnje će poduzeti ukoliko dužnik ne ispuni svoje obveze.</p>
    <p>Vjerovnik nije dužan postupati po sadržaju opomene te može poslati još opomena nakon što je izjavio da je poslao "zadnju opomena" i sl..</p>
    <p>Kako opomena ne stvara pravne obveze za nijednu od strana, tekst opomene nije propisan niti jednim zakonom, stoga vjerovnik sastavlja tekst opomene prema vlastitom nahođenju i interesu.</p>
    <p>Važno je naglasiti da ne postoji institut "zadnje opomene", "treće opomene" i sl., nakon koje se može pokrenuti postupak prisilne naplate, nego se postupak prisilne naplate može pokrenuti u bilo kojem trenutku, prije opomene, tijekom roka koji je određen opomenom i sl..</p>

    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Tumačenje da opomena prekida tijek zastare</strong></p>
    <p>Pojašnjenje: opomenom se ne prekida tijek zastare.</p>

    <p><strong>- Tumačenje da dužnika treba opomenuti da bi zatezne kamate počele teći</strong></p>
    <p>Pojašnjenje: opomena ne utječe na tijek zateznih kamata. </p>

    
  `,
  sides: [
    {
      prefix: "",
      signature: "",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto i poštanski broj",
      },
      {
        type: "input",
        required: false,
        placeholder: "Ostali podaci po potrebi",
      },
    ],
      suffix: "",
    }
  ],

  headline: "",
   
   title: 'Opomena pred utuženje',
   noArticleNumbers: true,
   noArticleTitle: true,

  articles: [
    {
        title: '',
        mandatory: true,
        dummy: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Poštovani,\r\n\r\nuvidom u naše poslovne knjige na dan _______ godine, utvrdili smo da postoji Vaše dospjelo, a nepodmireno dugovanje u iznosu od ________ kn. \r\nOvim putem Vas pozivamo da navedeno dugovanje podmirite u roku od 8 dana od dana primitka ove opomene.\r\nUkoliko dobrovoljno ne podmirite navedeno dugovanje u ostavljenom roku, biti ćemo primorani odmah po proteku navedenog roka poduzeti daljnje pravne radnje u cilju naplate navedenog potraživanja, a što će Vam prouzročiti dodatne visoke i nepotrebne troškove. \r\n\r\nS poštovanjem.',
                value: '',
            }],
    },
   
               {
                mandatory: true,
                static: true,
                type: 2, // date and place
                statements: [
                  {
                    type: "input",
                    mandatory: true,
                    parts: [
                      {
                        type: "text",
                        content: "U"
                      },
                      {
                        type: "input",
                        value: "",
                        placeholder: "Upišite mjesto.",
                        required: true,
                      },
                      {
                        type: "text",
                        content: ", dana"
                      },
                      {
                        type: "date",
                        value: new Date(),
                        required: true
                      },
                      {
                        type: "text",
                        content: "godine."
                      }
                    ]
                  },
                ]
              },
               {
                   mandatory: true,
                   static: true,
                   type: 3,  // signatures
                   statements: [],
               },
           ],
};












// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/51.2_opomena_pred_tuzbu.ts